<template>
  <v-dialog
    v-model="dialog"
    light
  >
    <template #activator="{ on, attrs }">
      <v-badge
        dot
        color="primary"
        offset-x="44"
        offset-y="14"
        :value="badge"
      >
        <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          :disabled="loading"
        >
          <v-icon v-text="icons[icon ?? filter]" />
        </v-btn>
      </v-badge>
    </template>
    <v-card>
      <v-toolbar
        flat
        dense
        color="grey lighten-4"
      >
        <v-icon left v-text="icons[icon ?? filter]" />
        <v-toolbar-title v-text="__(title ?? filter)" class="text-h6" />
        <v-spacer />
        <v-btn
          icon
          color="primary"
          @click="dialog = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pt-8">
        <v-row>
          <v-col v-text="minLabel" />
          <v-col v-text="maxLabel" class="text-right" />
        </v-row>
        <v-range-slider
          v-model="range"
          :min="min"
          :max="max"
          :step="step"
          hide-details
          track-color="grey"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="grey darken-1"
          v-text="__('cancel')"
          @click="reset()"
        />
        <v-spacer />
        <v-btn
          v-text="__('done')"
          text
          color="primary"
          @click="done()"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      filter: {
        required: true,
        type: String,
      },
      icon: {
        type: String,
      },
      title: {
        type: String,
      },
      min: {
        type: [String, Number],
        default: 0,
      },
      max: {
        type: [String, Number],
        default: 100,
      },
      step: {
        type: [String, Number],
        default: 1,
      },
    },

    data: () => ({
      dialog: false,
    }),

    computed: {
      ...mapState('history', [
        'loading',
        'filters',
      ]),
      minValue () {
        return this.filters[this.filter]?.min
      },
      minLabel () {
        return this.minValue ?? this.min
      },
      maxValue () {
        return this.filters[this.filter]?.max
      },
      maxLabel () {
        return this.maxValue === undefined || this.maxValue == this.max
          ? '∞'
          : this.maxValue
      },
      badge () {
        let v = false
        if (this.minValue !== undefined && this.minValue != this.min) {
          v = true
        }
        if (this.maxValue !== undefined && this.maxValue != this.max) {
          v = true
        }

        return v
      },
      range: {
        get () {
          return [
            this.minValue ?? this.min,
            this.maxValue ?? this.max,
          ]
        },
        set (v) {
          const filter = { key: this.filter }
          if (v[0] != this.min) {
            filter.min = v[0]
          }
          if (v[1] != this.max) {
            filter.max = v[1]
          }
          if (filter.min !== this.minValue || filter.max !== this.maxValue) {
           this.$store.commit('history/filter', filter)
          }
        },
      },
    },

    methods: {
      reset () {
        this.range = [this.min, this.max]
        this.done()
      },
      done () {
        this.dialog = false
      },
    },
  }
</script>
